import CarrinhoService from '@/modules/carrinho/carrinho-service';
import {
  GET_ITENS, ADD_ITEM, REMOVE_ITEM, REMOVE_CARRINHO,
} from './actions.type';
import { SET_ITENS, LOADING } from './mutations.type';

export default {
  [GET_ITENS](context) {
    context.commit(LOADING, true);
    CarrinhoService.getItensCarrinho({})
      .then((response) => {
        context.commit(SET_ITENS, response.data);
      })
      .finally(() => {
        context.commit(LOADING, false);
      });
  },
  [ADD_ITEM](context, id) {
    context.commit(LOADING, true);
    return CarrinhoService.adicionarProduto(id)
      .then((response) => {
        context.dispatch(GET_ITENS);
        return response.data;
      })
      .finally(() => {
        context.commit(LOADING, false);
      });
  },
  [REMOVE_ITEM](context, id) {
    context.commit(LOADING, true);
    return CarrinhoService.removerProduto(id)
      .then((response) => {
        context.dispatch(GET_ITENS);
        return response.data;
      })
      .finally(() => {
        context.commit(LOADING, false);
      });
  },
  [REMOVE_CARRINHO](context, id) {
    context.commit(LOADING, true);
    return CarrinhoService.removerResposta(id)
      .then((response) => {
        context.dispatch(GET_ITENS);
        return response.data;
      })
      .catch(() => {
        context.commit(LOADING, false);
      });
  },
};
